import { StoreCoupon, isCouponValid, formatCouponText } from "./types";

interface CouponBadgeProps {
  coupon: StoreCoupon;
  className?: string;
  style?: React.CSSProperties;
}

export const CouponBadge: React.FC<CouponBadgeProps> = ({
  coupon,
  className = "",
  style,
}) => {
  if (!isCouponValid(coupon)) {
    return null;
  }

  return (
    <div
      className={`bg-black text-white px-4 py-1.5 rounded-full shadow-md ${className}`}
      style={style}
    >
      <p className="text-sm font-semibold">
        {formatCouponText(coupon.discountValue)}
      </p>
    </div>
  );
};
